import { UpdateGalleryBlocksFormList } from '../formLists/UpdateGalleryBlocksFormList';

export const UpdatePageGalleryFormPart = () => {
  return <UpdateGalleryBlocksFormList fieldName={['content', 'gallery']} />;
};
